export default __webpack_public_path__ + "assets/images/checkbox-bg-6225684b.svg";